import { cn } from "@/lib/utils"

interface PageLoaderProps {
    className?: string
}

export function PageLoader({ className }: PageLoaderProps) {
    return (
        <div className={cn("flex h-full min-h-[300px] w-full items-center justify-center", className)}>
            <div className="page-loader" aria-label="Loading..." role="status" />
        </div>
    )
}
